import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { AppProviders } from "@/lib/providers";
import { ClientOnlySupertokens } from "@/components/ClientOnlySupertokens";
import { Toaster } from "@/components/ui/toaster";
import "@/styles/globals.css";

export default function RootLayout() {
  useEffect(() => {
    document.title = "Airloom";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "AI-powered video search platform",
      );
    } else {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      metaDescription.setAttribute(
        "content",
        "AI-powered video search platform",
      );
      document.head.appendChild(metaDescription);
    }
  }, []);

  return (
    <AppProviders>
      <ClientOnlySupertokens>
        <Outlet />
        <Toaster />
      </ClientOnlySupertokens>
    </AppProviders>
  );
}
